e4.breadcrumb = {
    init: function () {
        var jBreadcrumb = jQuery( '.js-e-breadcrumb' ),
            jBreadcrumbItemAppend = jQuery( '.js-e-breadcrumb-item-append' );
        if ( jBreadcrumb.length === 1 ) {
            if ( jBreadcrumbItemAppend.length === 1 ) {
                var jBreadcrumbItemLast = jBreadcrumb.find( '.breadcrumb-item' ).last(),
                    jBreadcrumbItemNew = jBreadcrumbItemLast.clone();
                if(jBreadcrumbItemLast.find( 'a' ).is('.js-e-back-link') === false){
                    jBreadcrumbItemNew.find( 'a' ).attr( 'href', jBreadcrumbItemAppend.data( 'link' ) );
                    jBreadcrumbItemNew.find( 'span' ).text( jBreadcrumbItemAppend.data( 'text' ) );
                    jBreadcrumbItemLast.after( jBreadcrumbItemNew );
                }

            }
            e4.breadcrumb.hideBreadcrumbsOnProductPage( jBreadcrumb );
        }

    },
    hideBreadcrumbsOnProductPage: function ( jBreadcrumb ) {
        if ( jQuery( '.js-e-product' ).length === 1 ) {
            var jBackLink = jBreadcrumb.find( '.js-e-back-link' );
            jBreadcrumb.find( '.breadcrumb-item' ).hide();
            jBackLink.closest( '.breadcrumb-item' ).find( 'a' ).not( '.js-e-back-link' ).hide();
            jBackLink.closest( '.breadcrumb-item' ).show();
            jBreadcrumb.removeClass( 'd-none' );
        }
    }
};

